import { useState } from 'react';
import Input from '../../../../../commons/Input/Input';
import Select from '../../../../../commons/Select/Select';
import TextArea from '../../../../../commons/TextArea/TextArea';
import { ConsultationItemType, CreateConsultSecondStepItemProps } from './CreateConsultSecondStepItem.types';
import { SelectOption } from '../../../../../commons/Select/Select.types';

const VenteItem = ({
  index,
  data,
  isLast,
  onChange,
  onAdd,
  onRemove,
}: Omit<CreateConsultSecondStepItemProps, 'type'>) => {
  return (
    <div className="createConsultSecondStepItem__vente">
      <input
        className="input__input"
        placeholder="Quantité"
        type="number"
        defaultValue={data.quantity || 1}
        onChange={(e) => {
          onChange(index, {
            ...data,
            quantity: parseInt(e.target.value),
          });
        }}
        style={{
          width: 50,
        }}
      />
      <TextArea
        id={`description-${index + 1}`}
        placeholder="Description"
        divProps={{
          style: {
            flex: 1,
          },
        }}
        style={{
          borderRadius: 0,
          resize: 'vertical',
        }}
        value={data.description}
        onChange={(e) => {
          onChange(index, {
            ...data,
            description: e.target.value,
          });
        }}
      />
      {isLast ? (
        <button
          onClick={(e) => {
            e.preventDefault();
            onAdd(ConsultationItemType.Service);
          }}>
          +
        </button>
      ) : (
        <button
          onClick={(e) => {
            e.preventDefault();
            onRemove(index);
          }}>
          -
        </button>
      )}
    </div>
  );
};

const ServiceItem = ({
  index,
  data,
  type,
  isLast,
  onChange,
  onAdd,
  onRemove,
}: CreateConsultSecondStepItemProps) => {
  return (
    <div className="createConsultSecondStepItem__vente service">
      {/* Uncomment if needed to indent the description textarea as VenteItem */}
      {/* <Input
        placeholder="Quantité"
        type="number"
        divProps={{
          style: {
            opacity: 0
          }
        }}
      /> */}
      <TextArea
        id={`description-${index + 1}`}
        placeholder="Description"
        divProps={{
          style: {
            flex: 1,
          },
        }}
        value={data.description}
        onChange={(e) => {
          onChange(index, {
            ...data,
            description: e.target.value,
          });
        }}
      />
      {isLast ? (
        <button
          onClick={(e) => {
            e.preventDefault();
            // @ts-ignore
            onAdd(type);
          }}>
          +
        </button>
      ) : (
        <button
          onClick={(e) => {
            e.preventDefault();
            onRemove(index);
          }}>
          -
        </button>
      )}
    </div>
  );
};

const PickableItem = ({
  key,
  index,
  data,
  isLast,
  onChange,
  onAdd,
  onRemove,
}: Omit<CreateConsultSecondStepItemProps, 'type'>) => {

  const [currentType, setCurrentType] = useState<ConsultationItemType>(data.type);

  return (
    <div className="flex-column">
      <div className="createConsultSecondStepItem__vente">
        <Input
          placeholder="Quantité"
          type="number"
          divProps={{
            style: {
              // opacity: 0,
              display: 'none'
            },
          }}
        />
        <Select
          // @ts-ignore
          style={{ flex: 1 }}
          divProps={{
            style: {
              flex: 1,
            },
          }}
          placeholder="Type de prestation"
          options={[
            {
              label: ConsultationItemType.Products,
              value: ConsultationItemType.Products,
            },
            {
              label: ConsultationItemType.Service,
              value: ConsultationItemType.Service,
            },
          ]}
          defaultValue={{
            value: data.type,
            label: data.type
          }}
          // @ts-ignore
          onChange={({ value }: SelectOption) => {
            const currentType = value as ConsultationItemType;
            setCurrentType(currentType);
            onChange(index, {
              ...data,
              type: currentType,
              quantity: currentType == ConsultationItemType.Products ? 0 : null,
            });
          }}
        />
        <button
          style={{ display: 'none' }}
          onClick={(e) => {
            e.preventDefault();
            onRemove(index);
          }}>
          -
        </button>
      </div>
      {currentType === ConsultationItemType.Products && (
        <VenteItem {...{ key, index, data, isLast, onChange, onAdd, onRemove }} />
      )}
      {currentType === ConsultationItemType.Service && (
        <ServiceItem
          type={currentType}
          {...{ key, index, data, isLast, onChange, onAdd, onRemove }}
        />
      )}
    </div>
  );
};

// const getCurrentComponentType = (type: ConsultationType) => {
//   switch (type) {
//     case ConsultationType.Fournitures:
//       return VenteItem;
//     case ConsultationType.Services:
//       return ServiceItem;
//     case ConsultationType.TravauxBatiment:
//       return ServiceItem;
//     case ConsultationType.TravauxPublics:
//       return ServiceItem;
//     case ConsultationType.LesDeux:
//       return PickableItem
//     default:
//       return ServiceItem;
//   }
// };

export default ({
  key,
  type,
  index,
  data,
  isLast,
  onChange,
  onAdd,
  onRemove,
}: CreateConsultSecondStepItemProps) => {

  // const [selectedType, setSelectedType] = useState<ConsultationItemType>(ConsultationItemType.Service)

  // const getCurrentComponentType = useCallback(
  //   () => {
  //     switch (type) {
  //       case ConsultationType.Fournitures:
  //         return VenteItem;
  //       case ConsultationType.Services:
  //         return ServiceItem;
  //       case ConsultationType.TravauxBatiment:
  //         return ServiceItem;
  //       case ConsultationType.TravauxPublics:
  //         return ServiceItem;
  //       case ConsultationType.LesDeux:
  //         return PickableItem
  //       default:
  //         return ServiceItem;
  //     }
  //   },
  //   [selectedType]
  // )

  // const CurrentItem = getCurrentComponentType();
  // CurrentItem

  return (
    <div className="createConsultSecondStepItem">
      {/* <div className='flex-row'>
        <div 
          className={
            `dashboard-companies__header-filters-item ${
              selectedType === ConsultationItemType.Service
                ? 'dashboard-companies__header-filters-item--active'
                : ''
            }`
          }
          onClick={() => setSelectedType(ConsultationItemType.Service)}
        >
          {ConsultationItemType.Service}
        </div>
        <div 
          className={
            `dashboard-companies__header-filters-item ${
              selectedType === ConsultationItemType.Products
                ? 'dashboard-companies__header-filters-item--active'
                : ''
            }`
          }
          onClick={() => setSelectedType(ConsultationItemType.Products)}
        >
          {ConsultationItemType.Products}
        </div>
      </div> */}
      <PickableItem {...{ key, index, data, type, isLast, onChange, onAdd, onRemove }} />
    </div>
  );
};
